import { render, staticRenderFns } from "./DashFeeProjection.vue?vue&type=template&id=1a987fd1&scoped=true&"
import script from "./DashFeeProjection.vue?vue&type=script&lang=js&"
export * from "./DashFeeProjection.vue?vue&type=script&lang=js&"
import style0 from "./DashFeeProjection.vue?vue&type=style&index=0&id=1a987fd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a987fd1",
  null
  
)

export default component.exports